<template>
  <a-row id="secondStep" style="width: 100%">
    <a-form-model
      v-if="rightAccess == 2"
      id="my_form_styl"
      ref="form"
      :model="form"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <div style="margin-bottom: 10px; font-weight: 700">
        {{ sale_record.invoiceAutoNumber + " " + sale_record.invoiceTitle }}
      </div>
      <a-row :gutter="16" type="flex" justify="space-between">
        <a-col
          :span="14"
          style="
            border: 1px solid rgb(211, 211, 211);
            border-radius: 5px;
            padding: 0;
            border-bottom: none;
            height: fit-content;
          "
        >
          <a-form-model-item :label="$t('Spółka')" prop="company">
            <div>
              <a
                :href="`https://${domain}/crm/company/details/${myCompany.ID}/`"
                target="_blank"
                >{{ myCompany.TITLE }}</a
              >
            </div>
          </a-form-model-item>
          <a-form-model-item :label="$t('Konto bankowe')" prop="bankAccaunt">
            <div>{{ sale_record.bankAccount }}</div>
          </a-form-model-item>
          <a-form-model-item :label="$t('Kontrahent')" prop="contractor">
            <div>
              <a
                :href="`https://${domain}/crm/company/details/${contractor.ID}/`"
                target="_blank"
                >{{ contractor.TITLE }}</a
              >
            </div>
          </a-form-model-item>
          <a-form-model-item :label="$t('Opiekun')">
            <div>{{ this.user.NAME + " " + this.user.LAST_NAME }}</div>
          </a-form-model-item>
          <a-form-model-item :label="$t('Projekt')">
            <div>
              <a
                :href="`https://${domain}/crm/deal/details/${DEAL.ID}/`"
                target="_blank"
                >{{ this.DEALPROJECT.TITLE }}</a
              >
            </div>
          </a-form-model-item>
          <a-form-model-item :label="$t('Rodzaj')" prop="invoiceType">
            <div>{{ sale_record.invoiceType }}</div>
          </a-form-model-item>
          <a-form-model-item :label="$t('Payment')" prop="paymentType">
            <div>{{ sale_record.paymentType }}</div>
          </a-form-model-item>
          <a-form-model-item
            :label="$t('Waluta, kurs')"
            prop="currency"
            class="last-block-item"
          >
            <a-row :gutter="16">
              <a-col :span="12">
                <div>{{ sale_record.currency }}</div>
              </a-col>
              <a-col :span="12">
                <div>{{ sale_record.course }}</div>
              </a-col>
            </a-row>
          </a-form-model-item>
        </a-col>
        <a-col
          :span="9"
          style="
            padding: 0;
            border: 1px solid rgb(211, 211, 211);
            border-radius: 5px;
            border-bottom: none;
            height: fit-content;
          "
        >
          <a-form-model-item :label="$t('Data wystawienia')" prop="billingDate">
            <div>{{ sale_record.billingDate }}</div>
          </a-form-model-item>
          <a-form-model-item :label="$t('Data sprzedaży')" prop="saleDate">
            <div>{{ sale_record.saleDate }}</div>
          </a-form-model-item>
          <a-form-model-item :label="$t('Data usługi')">
            <div>{{ sale_record.serviceDate }}</div>
          </a-form-model-item>
          <a-form-model-item :label="$t('Termin płatności')" prop="dueDate">
            <div>{{ sale_record.dueDate }}</div>
          </a-form-model-item>
          <a-form-model-item :label="$t('Przypomnienie')" prop="reminder">
            <div>{{ sale_record.reminder }}</div>
          </a-form-model-item>
          <a-form-model-item
            v-if="
              this.sale_record.invoiceCorrection != '' ||
              this.sale_record.correctionBack != ''
            "
            label="Korekta"
          >
            <a @click="showDrawer">{{ titleCorrectionInv }}</a>
          </a-form-model-item>
          <a-form-model-item :label="$t('Opis')">
            <div>{{ sale_record.description }}</div>
          </a-form-model-item>
          <a-form-model-item :label="$t('Język')" class="last-block-item">
            <div>{{ sale_record.language }}</div>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16" style="margin-top: 25px">
        <a-table
          :columns="columns"
          tableLayout="auto"
          :scroll="{ x: true }"
          :data-source="dataSource"
          :pagination="{ hideOnSinglePage: true }"
          bordered
        ></a-table>
      </a-row>
    </a-form-model>

    <editAllStep
      v-if="rightAccess == 1"
      :info="info"
      :COMPANY_LIST="COMPANY_LIST"
      :MY_COMPANY_LIST="MY_COMPANY_LIST"
      :USER_LIST="USER_LIST"
      :VAT_LIST="VAT_LIST"
      :DEAL="DEALEDIT"
      :user_setup="user_setup"
      :sale_record="sale_record"
      ref="form"
      @checkPositionFunc="checkPositionFunc"
      @changeSpinning="changeSpinning"
      @onClose="onClose"
      @goSteps="goSteps"
      @onback="handlerBack"
    />

    <a-row :gutter="16" type="flex" justify="center" style="margin-top: 10px">
      <a-statistic
        :title='$t("Netto")'
        :value="sale_record.netto"
        style="margin-right: 25px"
        :precision="2"
      />
      <a-divider type="vertical" style="height: 5em" />
      <a-statistic
        :title='$t("Vat")'
        :value="sale_record.vat"
        style="margin-right: 25px; margin-left: 25px"
        :precision="2"
      />
      <a-divider type="vertical" style="height: 5em" />
      <a-statistic
        :title='$t("Brutto")'
        :value="sale_record.totalAmout"
        style="margin-left: 25px"
        :precision="2"
      />
    </a-row>

    <a-drawer
      :title="correctDATA.invoiceTitle"
      placement="right"
      :visible="visible"
      :width="900"
      :after-visible-change="afterVisibleChange"
      @close="onCloseDrawer"
    >
      <a-form
        id="my_form_styl"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        style="width: 100%"
      >
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Spółka')" prop="company">
              <div>
                <a
                  :href="`https://${domain}/crm/company/details/${myCompanyCorrection.ID}/`"
                  target="_blank"
                  >{{ myCompanyCorrection.TITLE }}</a
                >
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Data wystawienia')" prop="billingDate">
              <div>{{ correctDATA.billingDate }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Konto bankowe')" prop="bankAccaunt">
              <div>{{ correctDATA.bankAccount }}</div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Data sprzedaży')" prop="saleDate">
              <div>{{ correctDATA.saleDate }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Kontrahent')" prop="contractor">
              <div>
                <a
                  :href="`https://${domain}/crm/company/details/${contractorCorrection.ID}/`"
                  target="_blank"
                  >{{ contractorCorrection.TITLE }}</a
                >
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Data usługi')">
              <div>{{ correctDATA.serviceDate }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Opiekun')">
              <div>
                {{
                  this.userCorrection.NAME + " " + this.userCorrection.LAST_NAME
                }}
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Termin płatności')" prop="dueDate">
              <div>{{ correctDATA.dueDate }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Projekt')">
              <div>
                <a
                  :href="`https://${domain}/crm/deal/details/${DEALcorrection.ID}/`"
                  target="_blank"
                  >{{ DEALcorrection.TITLE }}</a
                >
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Przypomnienie')" prop="reminder">
              <div>{{ correctDATA.reminder }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Rodzaj')" prop="invoiceType">
              <div>{{ correctDATA.invoiceType }}</div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              v-if="
                this.correctDATA.invoiceCorrection != '' ||
                this.correctDATA.correctionBack != ''
              "
              label="Korekta"
            >
              <div>{{ this.sale_record.invoiceTitle }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Payment')" prop="paymentType">
              <div>{{ correctDATA.paymentType }}</div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Opis')">
              <div>{{ correctDATA.description }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Waluta, kurs')" prop="currency">
              <a-row :gutter="16">
                <a-col :span="12">
                  <div>{{ correctDATA.currency }}</div>
                </a-col>
                <a-col :span="12">
                  <div>{{ this.currencyAmoutCorrection }}</div>
                </a-col>
              </a-row>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Język')">
              <div>{{ correctDATA.language }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-table
            :columns="columns"
            tableLayout="auto"
            :scroll="{ x: true }"
            :data-source="dataSourceCorrection"
            :pagination="{ hideOnSinglePage: true }"
            bordered
          ></a-table>
        </a-row>
      </a-form>
    </a-drawer>
  </a-row>
</template>
<script>
import moment from "moment";
import { confirmAccountCreation } from "@/requestFunc";
import editAllStep from "@/components/sales_steps/editAllStep";


export default {
  components: {
    editAllStep,
  },
  props: [
    "COMPANY_LIST",
    "MY_COMPANY_LIST",
    "USER_LIST",
    "VAT_LIST",
    "info",
    "sale_record",
    "user_setup",
    "DEAL",
  ],
  data() {
    return {
      currencyAmout: "",
      domain: "",
      columns: [
        {
          title: this.$t("Nazwa produktu"),
          dataIndex: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: this.$t("Jednostka"),
          dataIndex: "units",
          scopedSlots: { customRender: "units" },
        },
        {
          title: this.$t("Rodzaj przychodu"),
          dataIndex: "type_arrival",
          scopedSlots: { customRender: "type_arrival" },
        },
        {
          title: this.$t("Stawka VAT"),
          dataIndex: "vat_rate",
          scopedSlots: { customRender: "vat_rate" },
        },
        {
          title: this.$t("Ilość"),
          dataIndex: "quantity",
          scopedSlots: { customRender: "quantity" },
        },
        {
          title: this.$t("Cena"),
          dataIndex: "unit_price",
          scopedSlots: { customRender: "unit_price" },
        },
        {
          title: this.$t("Netto"),
          dataIndex: "Netto",
        },
        {
          title: this.$t("Vat"),
          dataIndex: "Vat",
        },
        {
          title: this.$t("Brutto"),
          dataIndex: "Brutto",
        },
        {
          title: this.$t("Operacje"),
          dataIndex: "operation",
          width: 100,
          fixed: "right",
          scopedSlots: { customRender: "operation" },
        },
      ],
      rightAccess: 0,
      params: [],
      currencyAmoutCorrection: "",
      myCompanyCorrection: "",
      contractorCorrection: "",
      dataSourceCorrection: [],
      userCorrection: [],
      DEALPROJECT: [],
      DEALcorrection: "",
      myCompany: "",
      contractor: "",
      correctDATA: [],
      dataSource: [],
      DEALEDIT: [],
      titleCorrectionInv: "",
      cacheData: [],
      visible: false,
      user: [],
      editingKey: "",
      PRODUCT_LIST: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },
    };
  },
  methods: {
    moment,
    afterVisibleChange() {
    },
    showDrawer() {
      this.visible = true;
    },
    onCloseDrawer() {
      this.visible = false;
    },
    onClose(element) {
      this.$emit("onClose", element);
    },
    goSteps(element) {
      this.$emit("goSteps", element);
    },
    changeSpinning() {
      this.$emit("changeSpinning");
    },
    saveValues() {
      let data = {
        notUse: "createSaleAndSaveStageOne",
      };
      Object.assign(data, this.$refs.form.form);
      if (!Object.keys(this.sale_record)) {
        for (let key in data) {
          data[key] = {
            old: "",
            new: data[key],
          };
        }
      } else {
        for (let key in data) {
          if (key != "positions" || key != "ID") {
            if (key in this.sale_record && data[key] != this.sale_record[key]) {
              data[key] = {
                old: this.sale_record[key],
                new: data[key],
              };
            } else {
              delete data[key];
            }
          }
        }
      }
      //Object.assign(newdata, data);

      this.$emit("checkPositionFunc", this.dataSource);
      return data;
    },
    onSubmit(updateStatus) {

     
      this.changeSpinning();
      let format_moment = (date) =>
        date ? moment(date).format("YYYY-MM-DD") : "";
      if (this.rightAccess == 1) {
        this.$refs.form.form.billingDate = format_moment(
          this.$refs.form.form.billingDate
        );
        this.$refs.form.form.dueDate = format_moment(
          this.$refs.form.form.dueDate
        );
        this.$refs.form.form.serviceDate = format_moment(
          this.$refs.form.form.serviceDate
        );
        this.$refs.form.form.saleDate = format_moment(
          this.$refs.form.form.saleDate
        );
        this.$refs.form.form.reminder = format_moment(
          this.$refs.form.form.reminder
        );
      }

      var allDate = this.saveValues();
      allDate["updateStatus"] = updateStatus;
      confirmAccountCreation(this.sale_record.ID, allDate)
        .done((data) => {
          var res = JSON.parse(data);
          let prev = this.sale_record.status;
          this.sale_record.status = res.status;
          if (updateStatus == true) {
            this.onClose({ prev, next: res.status });
            this.goSteps(this.sale_record);
          } else {
             this.$emit("generatrDoc", res.docID);
          }
          this.$message.success(this.$t("Potwierdzenie zakończone!"));
        })
        .fail((e) => {
          console.error(e);
          this.$message.error(this.$t("Błąd potwierdzenia"));
        })
        .always(() => {
          this.changeSpinning();
        });
    },
  },
  mounted() {
    this.DEALEDIT = this.DEAL;
    BX24.callMethod("user.admin", {}, (result) => {
      if (result.error()) console.error(result.error());
      else {
        var isAdmin = result.data();
        BX24.callMethod("user.current", {}, (result) => {
          if (result.error()) console.error(result.error());
          else {
            var userCurrent = result.data();
            if (isAdmin == true) {
              this.rightAccess = 1;
            } else {
              if (this.user_setup.responsibleAll.includes(userCurrent.ID)) {
                this.rightAccess = 1;
              } else {
                this.rightAccess = 2;
              }
              if (this.rightAccess == 2) {
                this.DEALPROJECT =
                  this.DEAL.find((el) => el.ID == this.sale_record.project) ||
                  {};
              }
            }
          }
        });
      }
    });

    let auth = BX24.getAuth();
    this.domain = auth.domain;
    if (this.sale_record.invoiceCorrection) {
      BX24.callMethod(
        "entity.item.get",
        {
          ENTITY: "invoices",
          FILTER: { ID: this.sale_record.invoiceCorrection },
        },
        (result) => {
          if (result.error()) console.error(result.error());
          else {
            this.titleCorrectionInv = result.data()[0]["PROPERTY_VALUES"][
              "invoiceTitle"
            ];
            this.correctDATA = result.data()[0]["PROPERTY_VALUES"];
 
            this.dataSourceCorrection = JSON.parse(this.correctDATA.positions);
            this.currencyAmoutCorrection = this.info.currency.filter((el) => {
              if (this.correctDATA.currency == el.CURRENCY) return el;
            })[0].AMOUNT;

            this.myCompanyCorrection = this.info.company.filter((el) => {
              if (this.correctDATA.company == el.ID) return el;
            })[0];

            this.contractorCorrection = this.info.company.filter((el) => {
              if (this.correctDATA.contractor == el.ID) return el;
            })[0];

            this.userCorrection = this.info.data_user.filter((el) => {
              if (this.correctDATA.responsible == el.ID) return el;
            })[0];

            BX24.callMethod(
              "crm.deal.get",
              { id: this.correctDATA.project },
              (result) => {
                if (result.error()) console.error(result.error());
                else {
                  this.DEALcorrection = result.data();
                }
              }
            );
          }
        }
      );
    } else if (this.sale_record.correctionBack) {
      BX24.callMethod(
        "entity.item.get",
        {
          ENTITY: "invoices",
          FILTER: { ID: this.sale_record.correctionBack },
        },
        (result) => {
          if (result.error()) console.error(result.error());
          else {
            this.titleCorrectionInv = result.data()[0]["PROPERTY_VALUES"][
              "invoiceTitle"
            ];
            this.correctDATA = result.data()[0]["PROPERTY_VALUES"];

            this.dataSourceCorrection = JSON.parse(this.correctDATA.positions);
            this.currencyAmoutCorrection = this.info.currency.filter((el) => {
              if (this.correctDATA.currency == el.CURRENCY) return el;
            })[0].AMOUNT;

            this.myCompanyCorrection = this.info.company.filter((el) => {
              if (this.correctDATA.company == el.ID) return el;
            })[0];

            this.contractorCorrection = this.info.company.filter((el) => {
              if (this.correctDATA.contractor == el.ID) return el;
            })[0];

            this.userCorrection = this.info.data_user.filter((el) => {
              if (this.correctDATA.responsible == el.ID) return el;
            })[0];

            BX24.callMethod(
              "crm.deal.get",
              { id: this.correctDATA.project },
              (result) => {
                if (result.error()) console.error(result.error());
                else {
                  this.DEALcorrection = result.data()["TITLE"];
                }
              }
            );
          }
        }
      );
    }

    this.currencyAmout = this.info.currency.filter((el) => {
      if (this.sale_record.currency == el.CURRENCY) return el;
    })[0].AMOUNT;

    this.myCompany = this.sale_record.allCompany.filter((el) => {
      if (this.sale_record.company == el.ID) return el;
    })[0];

    this.contractor = this.sale_record.allCompany.filter((el) => {
      if (this.sale_record.contractor == el.ID) return el;
    })[0];

    this.user = this.sale_record.userInfo.filter((el) => {
      if (this.sale_record.responsible == el.ID) return el;
    })[0];

    this.dataSource = this.sale_record.positions;

    /*BX24.callMethod(
      "crm.deal.get",
      { id: this.sale_record.project },
      (result) => {
        if (result.error()) console.error(result.error());
        else {
          this.DEAL = result.data();
        }
      }
    );*/

    BX24.callMethod("crm.product.list", {}, (result) => {
      if (result.error()) console.error(result.error());
      else {
        this.PRODUCT_LIST = this.PRODUCT_LIST.concat(result.data());
        if (result.more()) result.next();
      }
    });

    BX24.fitWindow();
  },
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
.editable-add-btn {
  margin-top: 8px;
}
#salesForm2 .ant-form-item {
  margin-bottom: 0 !important;
}
#salesForm2 .ant-form-item-control,
#salesForm2 .ant-form-item-control-wrapper,
#salesForm2 .ant-form-item-label {
  padding: 0 !important;
  line-height: 1.2 !important;
}
</style>